const BannerIcon = ({ icon }) => icon;
export default BannerIcon;
